import React from 'react';
import PropTypes from 'prop-types';
import PDFViewer from './PDFViewer';
import './PDFViewerModal.scss';

/**
 * Modal wrapper for PDFViewer component
 * Provides a full-screen overlay with the PDF viewer
 */
const PDFViewerModal = ({
  isOpen,
  pdfData,
  fileName,
  factuurvoorstelnummer,
  annotations = [],
  onClose,
  onAnnotationClose,
}) => {
  if (!isOpen) return null;

  const handleOverlayClick = (e) => {
    // Only close if clicking directly on the overlay, not on content
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleContentClick = (e) => {
    // Prevent clicks inside the modal from closing it
    e.stopPropagation();
  };

  return (
    <div className="pdf-viewer-modal" onClick={handleOverlayClick}>
      <div className="pdf-viewer-modal__overlay" />
       <div className="pdf-viewer-modal__content" onClick={handleContentClick}>
         <PDFViewer
           pdfData={pdfData}
           fileName={fileName}
           factuurvoorstelnummer={factuurvoorstelnummer}
           annotations={annotations}
           onClose={onClose}
           onAnnotationClose={onAnnotationClose}
           showToolbar
         />
       </div>
    </div>
  );
};

PDFViewerModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  pdfData: PropTypes.string.isRequired,
  fileName: PropTypes.string.isRequired,
  factuurvoorstelnummer: PropTypes.string,
  annotations: PropTypes.array,
  onClose: PropTypes.func.isRequired,
  onAnnotationClose: PropTypes.func,
};

export default PDFViewerModal;
